module.exports = __webpack_public_path__ + "img/Frame.eb975fab.png";